import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface SiteBannerStoreState {
  dismissedBannerIds: string[];
}

interface SiteBannerStoreActions {
  dismissBanner: (id: string) => void;
}

export const useSiteBannerStore = create<SiteBannerStoreState & SiteBannerStoreActions>()(
  persist(
    (set) => ({
      dismissedBannerIds: [],
      dismissBanner: (id) => set((state) => (state.dismissedBannerIds.includes(id) ? state : { dismissedBannerIds: [...state.dismissedBannerIds, id] })),
    }),
    {
      name: 'gb-site-banners',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
